import SignIn from '../components/Auth/SignIn'
import SignUp from '../components/Auth/SignUp'
import ConfirmSignUp from '../components/Auth/ConfirmSignUp'
import VerifyContact from '../components/Auth/VerifyContact'
import ForgotPassword from '../components/Auth/ForgotPassword'
import AuthView from '../components/Auth/AuthView'
import store from '../store'

export default {
    path: '/auth',
    name: 'auth',
    component: AuthView,
    children: [
        {
            path: 'signIn',
            name: 'auth_SignIn',
            component: SignIn
        },
        {
            path: 'signUp',
            name: 'auth_SignUp',
            component: SignUp
        },
        {
            path: 'signOut',
            name: 'auth_SignOut',
            beforeEnter: async (to, from, next) => {
                const { query } = to
                await store.dispatch('auth/signOut')
                if (!query.q) {
                    next({ path: '/auth/signIn' })
                } else {
                    location.href = query.q
                }
                await store.dispatch('pools/emptyState')
            }
        },
        {
            path: 'confirmSignUp',
            name: 'auth_ConfirmSignUp',
            component: ConfirmSignUp
        },
        {
            path: 'verifyContact',
            name: 'auth_VerifyContact',
            component: VerifyContact
        },
        {
            path: 'forgotPassword',
            name: 'auth_ForgotPassword',
            component: ForgotPassword
        }
    ]
}
